import React, { useEffect, useState } from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";

export const ErrorChunk = () => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      window.location.reload();
    }, countdown * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <ErrorAlert
      title="Feature Update Announcement."
      errorCode="update"
      buttonTitle={`Refresh (${countdown}s)`}
      onClick={() => window.location.reload()}
    >
      <p>
        New features have been applied.
        <br />
        Please refresh the page (F5) to access the latest version.
      </p>
    </ErrorAlert>
  );
};
